import { NgModule } from '@angular/core';
import { TerminosCondicionesComponent } from './term_cond.component';

@NgModule({
    declarations: [
        TerminosCondicionesComponent
    ]
})
// tslint:disable-next-line:eofline
export class TerminosCondicionesModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/terminos_condiciones_app/term_cond.module.ts